var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.icons),function(icon,index){return _c('div',{key:index,staticClass:"legend"},[_c('i',{class:("icon-" + icon)}),_c('p',[_vm._v(_vm._s(icon))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }